import { render, staticRenderFns } from "./StripeBridgeFeatures.vue?vue&type=template&id=519b91c5&scoped=true"
import script from "./StripeBridgeFeatures.vue?vue&type=script&lang=js"
export * from "./StripeBridgeFeatures.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeFeatures.vue?vue&type=style&index=0&id=519b91c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b91c5",
  null
  
)

export default component.exports